import Vue from 'vue'
import Vuelidate from 'vuelidate'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/pt-br'
import VueTheMask from 'vue-the-mask'

import Root from '@/Root'
import store from '@/store'
import router from '@/router'
import http from '@/plugins/http'
import eventbus from '@/plugins/eventbus'

require('@/includes')
require('@/app/auth/include')

Vue.use(Vuelidate)
Vue.use(ElementUI, { locale })
Vue.use(VueTheMask)
Vue.use(http)
Vue.use(eventbus)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<Root/>',
  components: { Root }
})



// WEBPACK FOOTER //
// ./src/main.js